import getSymbolFromCurrency from 'currency-symbol-map';
export const parseModels = (data) => {
    const modelsData = data.collections.edges[0].node.products.edges;

    const modelList = modelsData.map((model) => {
        return {
            id: model.node.id,
            title: model.node.title,
            price: model.node.variants.nodes[0].price.amount,
            currency: getSymbolFromCurrency(model.node.variants.nodes[0].price.currencyCode),
            sku: model.node.variants.nodes[0].sku
        };
    });

    return modelList;
};

export const parseVairants = (data, unitId) => {
    let unitIdTrimed = unitId.split('/')[4];
    const variants = data.product.variants.nodes.map((variant) => {
        let id = variant.id.split('/');
        return {
            id: id[4],
            title: variant.title,
            price: variant.price.amount,
            sku: variant.sku,
            currency: getSymbolFromCurrency(variant.price.currencyCode)
        };
    });
    return {
        title: data.product.title,
        id: unitIdTrimed,
        sku: variants[0].sku,
        currency: variants[0].currency,
        variants: variants
    };
};
